import { Component } from '@angular/core';
import { ClassTransformerHelper } from '../../../../helpers/class.transformer.helper';
import { WorkflowType } from '../../../../models/enums/workflowtype.enum';
import { MailSettingsService } from '../../../../services/mailsettings.service';
import { ObsoleteInfo, WorkflowExitInfo, WorkflowModuleSettingsHelper, WorkflowRegistry } from '../../../../services/workflow.service';
import { FormulaWorkflowDialogContent, WorkflowDialogContent } from '../../../workflow.dialog';

@Component({
    selector: 'wf-sendmail-settings',
    templateUrl: './sendmail.settings.html'
})
export class SendMailSettings extends WorkflowDialogContent {
    MailSettings = [];
    Data = new SendMailSettingsData();

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = 'sendmailWFModule';
        reg.Caption = '@@Email senden';
        reg.GroupID = 'wfActions';
        reg.Index = 40;
        reg.SettingsControl = SendMailSettings;
        reg.SettingsTypeHelper = new SendMailSettingsDataHelper();
        reg.WorkflowType = WorkflowType.Service;
        reg.ObsoleteInfo = new ObsoleteInfo();
        reg.ObsoleteInfo.ReplacedBy = SendMailExtendedSettings.ModuleID;
        return reg;
    }

    constructor(private service: MailSettingsService) {
        super();
    }

    ngOnInit() {
        this.service.GetMailSettings().subscribe(result => {
            if (result) {
                this.MailSettings = result;
            }
        });
    }

    initialize(data: any) {
        if (data) {
            this.Data = ClassTransformerHelper.CopyObject(data, SendMailSettingsData);
        }
    }

    getResult() {
        return this.Data;
    }
}

export abstract class AMailSettingsData {
    MailServer: string;
    To: string;
    Subject: string;
    Body: string;
}

export class SendMailSettingsData extends AMailSettingsData {
}

export class SendMailSettingsDataHelper extends WorkflowModuleSettingsHelper {
    getExitPoints(settings: any): WorkflowExitInfo[] {
        return [new WorkflowExitInfo()];
    }
    getEmptySettingsInstance() {
        return new SendMailSettingsData();
    }
}

@Component({
    selector: 'wf-sendmail-extended-settings',
    templateUrl: './sendmail.extended.settings.html'
})
export class SendMailExtendedSettings extends FormulaWorkflowDialogContent {
    static ModuleID = 'sendmailExtendedWFModule';

    MailSettings = [];
    Data = new SendMailExtendedSettingsData();

    public static GetRegistry(): WorkflowRegistry {
        const reg = new WorkflowRegistry();
        reg.ID = SendMailExtendedSettings.ModuleID;
        reg.Caption = '@@Email senden';
        reg.GroupID = 'wfActions';
        reg.Index = 40;
        reg.SettingsControl = SendMailExtendedSettings;
        reg.SettingsTypeHelper = new SendMailExtendedSettingsDataHelper();
        reg.WorkflowType = WorkflowType.Service;
        return reg;
    }

    constructor(private service: MailSettingsService) {
        super();
    }

    ngOnInit() {
        this.service.GetMailSettings().subscribe(result => {
            if (result) {
                this.MailSettings = result;
            }
        });
    }

    initialize(data: any) {
        super.initialize(data);
        if (data) {
            this.Data = ClassTransformerHelper.CopyObject(data, SendMailExtendedSettingsData);
        }
    }

    getResult() {
        return this.Data;
    }
}

export class SendMailExtendedSettingsData extends AMailSettingsData {
}

export class SendMailExtendedSettingsDataHelper extends WorkflowModuleSettingsHelper {
    getExitPoints(settings: any): WorkflowExitInfo[] {
        return [new WorkflowExitInfo()];
    }
    getEmptySettingsInstance() {
        return new SendMailExtendedSettingsData();
    }
}
